<template>
  <div :class="{ player: true, bg: showSongContent }" :style="playerThemeStyle">
    <!-- <transition name="el-fade-in">
      <div class="hint" v-show="hint"></div
    ></transition> -->
    <el-tooltip
      class="item"
      effect="dark"
      content="打开播放器"
      placement="left"
    >
      <div class="open-play" v-show="!showAll" @click="showAll = true">
        <i class="el-icon-video-play"></i>
      </div>
    </el-tooltip>
    <!-- <div
      class="hand"
      title="展开 / （点击）收起播放条"
      v-show="!showSongContent"
      @click="(showAll = !showAll), (showVolume = false)"
    ></div> -->
    <el-tooltip
      class="item"
      effect="dark"
      content="收起播放器"
      placement="top"
      v-show="showAll && !showSongContent"
    >
      <div class="open-play-btn" @click="showAll = false">
        <i class="el-icon-arrow-down"></i>
      </div>
    </el-tooltip>
    <transition name="el-zoom-in-bottom">
      <!-- 歌词展示 -->
      <div class="content" v-show="showSongContent" ref="content">
        <img :src="playContent.picUrl" class="img_bg" alt="" />
        <div class="singer_content">
          <div class="close" @click="tapShowSongContent" title="收取音乐详情页">
            <i class="el-icon-arrow-down c-white"></i>
          </div>
          <div class="album hidden-sm-only hidden-xs-only">
            <img
              src="@/assets/images/stylus.png"
              alt="唱针"
              :class="['stylus', 'tst-2', playStatus ? 'stylus-rotate' : '']"
            />
            <div
              class="album_img"
              ref="album_img"
              :style="{ animationPlayState: playStatus ? 'running' : 'paused' }"
            >
              <img :src="playContent.picUrl" alt="" v-if="playContent.picUrl" />
              <img src="@/assets/images/default-cover.jpg" v-else />
              <div class="msk"></div>
            </div>
          </div>
          <div class="song_content">
            <div class="song_name one-ellipsis">
              {{ playContent.songName }}
            </div>
            <div class="song_detail">
              <div class="album_name">
                <span>专辑：</span>
                <a href="javascript:;" title="爱爱爱">--</a>
              </div>
              <div class="singer_name">
                <span>歌手：</span>
                <a href="javascript:;" :title="playContent.singerName">{{
                  playContent.singerName
                }}</a>
                <!-- <router-link
                  :to="
                    '/singerdetails?s_id=' +
                    playContent.s_id +
                    '&singerName=' +
                    playContent.singerName
                  "
                  :title="playContent.singerName"
                  >{{ playContent.singerName }}</router-link
                > -->
              </div>
            </div>
            <div class="song_word_content">
              <div class="lyric_loading" v-show="loading">
                <span>加载歌词中...</span>
              </div>
              <ul ref="lyricUL" class="lyric_ul" v-show="!loading">
                <li
                  v-for="(item, i) in lyricsObjArr"
                  :style="{
                    // color: lyricIndex === i ? '#ff5a8d' : '',
                    // fontSize: lyricIndex === i ? '16px' : '14px',
                    // opacity: lyricIndex === i ? 1 : '',
                    // fontWeight: lyricIndex === i ? 'bold' : 'normal',
                  }"
                  :class="[lyricIndex === i ? 'active' : '', 'lyric']"
                  :key="item.uid"
                  :data-index="i"
                  ref="lyric"
                >
                  {{ item.lyric }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <!-- 播放器 -->
    <transition name="el-zoom-in-bottom">
      <el-row :class="['all', !showSongContent ? 'bg' : '']" v-show="showAll">
        <el-col
          :span="6"
          :class="[
            'g_flag',
            playContent.songName ? '' : 'v-hide',
            'hidden-xs-only',
          ]"
        >
          <div class="head">
            <a href="javascript:;">
              <el-button
                class="modal"
                type="text"
                :icon="
                  !showSongContent ? 'el-icon-arrow-up' : 'el-icon-arrow-down'
                "
                @click="tapShowSongContent"
              >
              </el-button>
              <img
                :src="playContent.picUrl"
                :alt="playContent.songName"
                v-if="playContent.picUrl"
              />
              <img src="@/assets/images/default-cover.jpg" v-else />
            </a>
          </div>
          <div class="words">
            <div class="title" :title="playContent.songName">
              <router-link
                :to="'/songdetails?id=' + playContent.m_id"
                :class="['song_name', showSongContent ? 'c-white' : '']"
                >{{ playContent.songName }}</router-link
              >
              <i
                :class="[
                  'iconfont',
                  'icon-jurassic_love',
                  showSongContent ? 'c-white' : '',
                ]"
              ></i>
            </div>
            <router-link
              :to="
                '/singerdetails?s_id=' +
                playContent.s_id +
                '&singerName=' +
                playContent.singerName
              "
              v-if="playContent.s_id"
              :class="['con', 'c-pointer', showSongContent ? 'c-white' : '']"
              >{{ playContent.singerName }}</router-link
            >
            <span
              :class="['con', 'c-pointer', showSongContent ? 'c-white' : '']"
              v-else
              >{{ playContent.singerName }}</span
            >
          </div>
        </el-col>
        <el-col :span="12" :xs="24" class="tool">
          <audio
            v-if="playContent.song_filepath"
            :src="playContent.song_filepath"
            ref="audio"
            preload="metadata"
            @loadedmetadata="onLoadedMetadata"
            @timeupdate="onTimeUpdate"
            @play="onAudioPlay"
            @pause="onAudioPause"
            @ended="onAudioEnded"
            @error="onAudioError"
          ></audio>
          <div class="btns">
            <a
              href="javascript:;"
              :class="['tst-5', showSongContent ? 'c-white' : '']"
              :title="playModeIcon[playModeIndex].title"
              @click="playMode()"
            >
              <i :class="['iconfont', playModeIcon[playModeIndex].icon]"></i>
            </a>
            <el-button
              type="text"
              icon="iconfont icon-shangyishou"
              :class="['prv', showSongContent ? 'c-white' : '']"
              title="上一首"
              aria-label="上一首"
              :disabled="!canSwitchSong"
              @click="lastMusic"
            ></el-button>
            <el-button
              type="text"
              :class="['ply', showSongContent ? 'ply2' : '']"
              icon="iconfont icon-24gf-play"
              @click="play"
              title="播放/暂停"
              aria-label="播放"
              :disabled="!hasCurrentSong"
              v-show="!playStatus"
            ></el-button>
            <el-button
              type="text"
              :class="['ply', showSongContent ? 'ply2' : '']"
              icon="iconfont icon-24gf-pause2"
              @click="pause"
              title="播放/暂停"
              aria-label="暂停"
              v-show="playStatus"
            ></el-button>
            <el-button
              type="text"
              icon="iconfont icon-xiayishou"
              :class="['nxt', showSongContent ? 'c-white' : '']"
              title="下一首"
              aria-label="下一首"
              :disabled="!canSwitchSong"
              @click="nextMusic"
            ></el-button>
            <el-button
              type="text"
              icon="iconfont icon-geciweidianji"
              :class="['lyricShow', 'tst-2', showSongContent ? 'c-white' : '']"
              title="歌词展示"
              aria-label="歌词展示"
              @click="playContent.songName ? tapShowSongContent() : ''"
            ></el-button>
            <el-button
              type="text"
              icon="iconfont icon-24gf-playlistMusic5"
              :class="[
                'menu',
                'mobile_menu',
                'hidden-sm-and-up',
                showSongContent ? 'c-white' : '',
              ]"
              @click="drawer = true"
              title="播放列表"
            ></el-button>
          </div>
          <el-row :gutter="10" type="flex" justify="center" class="g_pbar">
            <el-col
              :span="2"
              :class="['time', showSongContent ? 'c-white' : '']"
              ><span v-if="playContent.m_id">{{
                formatTime(displayCurrentTime)
              }}</span></el-col
            >
            <el-col :span="20" class="slider">
              <el-slider
                v-model="seekTime"
                :show-tooltip="false"
                :step="0.1"
                :max="sliderMax"
                :disabled="!hasCurrentSong || sliderMax <= 0"
                @mousedown.native="startSeeking"
                @mouseup.native="stopSeeking"
                @touchstart.native="startSeeking"
                @touchend.native="stopSeeking"
                @touchcancel.native="stopSeeking"
                @input="onSeekInput"
                @change="changeTime"
              ></el-slider>
            </el-col>
            <el-col
              :span="2"
              :class="['time_end', showSongContent ? 'c-white' : '']"
              ><span v-if="playContent.m_id">{{
                formatTime(sliderMax)
              }}</span></el-col
            >
          </el-row>
          <el-row
            v-show="showVolume"
            type="flex"
            justify="center"
            class="mobile_volume"
          >
            <el-slider
              v-model="volume"
              :show-tooltip="false"
              @input="changeVolume"
              @change="changeVolume"
            ></el-slider>
          </el-row>
        </el-col>
        <el-col
          :span="6"
          class="g_flag hidden-xs-only"
          style="justify-content: right"
        >
          <div class="ctrl">
            <a
              :href="playContent.song_filepath"
              target="_blank"
              :class="['open', showSongContent ? 'c-white' : '']"
              title="下载"
              ><i class="el-icon-download"
            /></a>
            <div
              class="volume"
              @mouseenter="showVolume = true"
              @mouseleave="showVolume = false"
              @focusin="showVolume = true"
              @focusout="showVolume = false"
            >
              <el-button
                type="text"
                icon="iconfont icon-bofang2"
                :class="['open', showSongContent ? 'c-white' : '']"
                title="音量"
                aria-label="音量"
                @click="toggleVolume"
              ></el-button>
              <el-slider
                v-model="volume"
                @input="changeVolume"
                @change="changeVolume"
                vertical
                height="60px"
                v-show="showVolume"
              ></el-slider>
            </div>
            <el-button
              type="text"
              icon="iconfont icon-24gf-playlistMusic5"
              :class="['menu', showSongContent ? 'c-white' : '']"
              @click="drawer = true"
              title="播放列表"
            ></el-button>
          </div>
        </el-col>
      </el-row>
    </transition>
    <!-- 播放列表 -->
    <el-drawer
      :title="'播放列表 ' + playListLength"
      :visible.sync="drawer"
      :direction="direction"
      :modal="false"
      resizable="true"
    >
      <!-- <el-row class="songList" v-for="item in playList" :key="item.m_id">
            <el-col>{{ item.songName }}</el-col>
            <el-col>{{ item.singerName }}</el-col>
            <el-col></el-col>
          </el-row> -->
      <el-table
        :data="playList"
        style="width: 100%"
        :row-class-name="tableRowClassName"
        @row-dblclick="rowDblClick"
        stripe
      >
        <!-- <el-table-column prop="songName" label="歌曲/歌手">
          <template v-slot="{ row }">
            <el-row type="flex">
              <el-image
                :src="row.picUrl"
                fit="cover"
                style="width: 45px; height: 45px"
                lazy
              >
                <div slot="placeholder" class="image-slot">
                  <img
                    src="@/assets/images/default-cover.jpg"
                    style="width: 100%; height: 100%"
                  />
                </div>
              </el-image>
              <div>
                <p class="one-ellipsis">
                  {{ row.songName }}
                </p>
                <p class="one-ellipsis">
                  <span class="artist">{{ row.singerName }}</span>
                </p>
              </div>
            </el-row>
          </template>
        </el-table-column> -->
        <el-table-column prop="songName" label="歌曲" align="center">
          <template v-slot="scope">
            <div class="one-ellipsis">
              <ul class="current_icon" v-if="isSameSong(scope.row)">
                <li></li>
                <li></li>
                <li></li>
              </ul>
              <span :title="scope.row.songName">{{ scope.row.songName }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="singerName" label="歌手" align="center">
          <template slot-scope="{ row }">
            <span class="one-ellipsis" :title="row.singerName">{{
              row.singerName
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="时长" align="center">
          <template v-slot="scope">
            <span class="c-999">{{
              $formatTime(scope.row.audioDuration)
            }}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-drawer>
  </div>
</template>

<script>
import bus from "@/views/eventBus";
export default {
  data() {
    return {
      loading: false,
      volume: 100, // 音量
      showVolume: false,
      lyricsObjArr: [],
      lyricIndex: -1,
      currentTime: 0,
      seekTime: 0,
      duration: 0,
      isSeeking: false,
      showSongContent: false,
      showAll: false,
      drawer: false,
      direction: "rtl", //播放列表的放置方向
      playList: [], //播放列表
      playListLength: 0, //播放列表歌曲数量
      playContent: {}, //当前播放的歌曲信息
      playStatus: false, //播放状态
      // 播放模式索引
      playModeIndex: 0,
      playModeIcon: [
        { title: "循环播放", icon: "icon-xunhuanbofang" },
        { title: "单曲循环", icon: "icon-danquxunhuan" },
        { title: "随机播放", icon: "icon-suijibofang" },
      ],
      // 随机模式上一首歌曲索引
      lastMusicIndex: 0,
      lyricRequestToken: 0,
      playMusicHandler: null,
      bodyOverflowBeforePlayer: null,
      themeToken: 0,
      playerThemeStyle: {
        "--player-theme-rgb": "65, 55, 55",
        "--player-theme-soft-rgb": "196, 178, 154",
        "--player-theme-deep-rgb": "24, 24, 28",
        "--player-theme-text-rgb": "255, 255, 255",
        "--player-theme-accent-rgb": "255, 100, 145",
      },
    };
  },
  computed: {
    hasCurrentSong() {
      return Boolean(this.playContent && this.playContent.m_id);
    },
    canSwitchSong() {
      return this.hasCurrentSong && this.playList.length > 1;
    },
    sliderMax() {
      const duration = Number(
        this.duration || this.playContent.audioDuration || 0,
      );
      return Number.isFinite(duration) ? duration : 0;
    },
    displayCurrentTime() {
      return this.isSeeking ? this.seekTime : this.currentTime;
    },
  },
  watch: {
    "playContent.picUrl"(url) {
      this.updatePlayerTheme(url);
    },
  },
  mounted() {
    this.playMusicHandler = (val) => {
      this.handlePlayMusic(val);
    };
    bus.$on("playMusic", this.playMusicHandler);
  },
  beforeDestroy() {
    if (this.playMusicHandler) {
      bus.$off("playMusic", this.playMusicHandler);
    }
    this.lyricRequestToken++;
    this.unlockBodyScroll();
  },
  methods: {
    getDefaultPlayerTheme() {
      return {
        "--player-theme-rgb": "65, 55, 55",
        "--player-theme-soft-rgb": "196, 178, 154",
        "--player-theme-deep-rgb": "24, 24, 28",
        "--player-theme-text-rgb": "255, 255, 255",
        "--player-theme-accent-rgb": "255, 100, 145",
      };
    },
    getCoverImageUrl(url) {
      if (!url) return "";
      if (/^(https?:)?\/\//.test(url) || url.startsWith("data:")) return url;
      return `${window.location.origin}${
        url.startsWith("/") ? url : `/${url}`
      }`;
    },
    clampColor(value) {
      return Math.max(0, Math.min(255, Math.round(value)));
    },
    mixColor(color, target, amount) {
      return color.map((value, index) =>
        this.clampColor(value + (target[index] - value) * amount),
      );
    },
    formatRgb(color) {
      return color.map((value) => this.clampColor(value)).join(", ");
    },
    async updatePlayerTheme(url) {
      const imageUrl = this.getCoverImageUrl(url);
      const token = ++this.themeToken;
      if (!imageUrl) {
        this.playerThemeStyle = this.getDefaultPlayerTheme();
        return;
      }

      try {
        const img = new Image();
        img.crossOrigin = "anonymous";
        img.decoding = "async";
        const loaded = new Promise((resolve, reject) => {
          img.onload = resolve;
          img.onerror = reject;
        });
        img.src = imageUrl;
        await loaded;
        if (token !== this.themeToken) return;

        const size = 36;
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d", { willReadFrequently: true });
        if (!ctx) throw new Error("canvas unsupported");

        canvas.width = size;
        canvas.height = size;
        const cropSize = Math.min(img.naturalWidth, img.naturalHeight) * 0.72;
        const sx = (img.naturalWidth - cropSize) / 2;
        const sy = (img.naturalHeight - cropSize) / 2;
        ctx.drawImage(img, sx, sy, cropSize, cropSize, 0, 0, size, size);

        const pixels = ctx.getImageData(0, 0, size, size).data;
        let r = 0;
        let g = 0;
        let b = 0;
        let count = 0;
        for (let i = 0; i < pixels.length; i += 4) {
          if (pixels[i + 3] < 80) continue;
          r += pixels[i];
          g += pixels[i + 1];
          b += pixels[i + 2];
          count++;
        }
        if (!count) throw new Error("empty cover color");

        const base = [r / count, g / count, b / count];
        const soft = this.mixColor(base, [255, 255, 255], 0.28);
        const deep = this.mixColor(base, [20, 20, 24], 0.55);
        const accent = this.mixColor(base, [255, 100, 145], 0.32);

        this.playerThemeStyle = {
          "--player-theme-rgb": this.formatRgb(base),
          "--player-theme-soft-rgb": this.formatRgb(soft),
          "--player-theme-deep-rgb": this.formatRgb(deep),
          "--player-theme-text-rgb": "255, 255, 255",
          "--player-theme-accent-rgb": this.formatRgb(accent),
        };
      } catch (error) {
        if (token === this.themeToken) {
          this.playerThemeStyle = this.getDefaultPlayerTheme();
        }
      }
    },
    async handlePlayMusic(val) {
      const song = val && val[0] && val[0].data;
      if (!song) return;

      this.playList = Array.isArray(val[1]) ? val[1] : [];
      this.playListLength = this.playList.length;
      await this.selectSong(song, { play: true });
    },
    async selectSong(song, { play = true } = {}) {
      if (!song) return;

      this.showAll = true;
      this.playContent = song;
      this.currentTime = 0;
      this.seekTime = 0;
      this.duration = Number(song.audioDuration) || 0;
      this.isSeeking = false;
      this.lyricIndex = -1;
      this.lyricsObjArr = [];
      this.resetLyricScroll();
      this.loadLyric(song.m_id);

      await this.$nextTick();
      const audio = this.$refs.audio;
      if (audio) {
        audio.volume = this.volume / 100;
        audio.load();
      }
      if (play) {
        await this.playAudio();
      }
    },
    async playAudio() {
      if (!this.hasCurrentSong || !this.playContent.song_filepath) return;

      await this.$nextTick();
      const audio = this.$refs.audio;
      if (!audio) return;

      try {
        await audio.play();
      } catch (error) {
        this.playStatus = false;
        if (!error || error.name !== "AbortError") {
          this.$message.warning("浏览器阻止了自动播放，请手动点击播放");
        }
      }
    },
    play() {
      this.playAudio();
    },
    pause() {
      const audio = this.$refs.audio;
      if (!audio) return;
      audio.pause();
    },
    onLoadedMetadata() {
      const audio = this.$refs.audio;
      const mediaDuration =
        audio && Number.isFinite(audio.duration) ? audio.duration : 0;
      this.duration =
        mediaDuration || Number(this.playContent.audioDuration) || 0;
    },
    onTimeUpdate() {
      const audio = this.$refs.audio;
      if (!audio) return;

      const time = audio.currentTime || 0;
      this.currentTime = time;
      if (!this.isSeeking) {
        this.seekTime = time;
      }
      this.updateActiveLyric(time);
    },
    onAudioPlay() {
      this.playStatus = true;
    },
    onAudioPause() {
      this.playStatus = false;
    },
    async onAudioEnded() {
      if (!this.hasCurrentSong) return;
      if (this.playModeIndex === 1 || this.playList.length <= 1) {
        await this.restartCurrentSong();
        return;
      }
      await this.playModeType();
    },
    onAudioError() {
      if (!this.hasCurrentSong) return;
      this.playStatus = false;
      this.$message.error("音频加载失败");
    },
    startSeeking() {
      this.isSeeking = true;
    },
    stopSeeking() {
      this.isSeeking = false;
    },
    onSeekInput(value) {
      this.seekTime = value;
    },
    changeTime(value = this.seekTime) {
      const audio = this.$refs.audio;
      const nextTime = Math.min(
        Math.max(Number(value) || 0, 0),
        this.sliderMax || Number.MAX_SAFE_INTEGER,
      );

      if (audio) {
        audio.currentTime = nextTime;
      }
      this.currentTime = nextTime;
      this.seekTime = nextTime;
      this.isSeeking = false;
      this.updateActiveLyric(nextTime, { immediate: true });
    },
    formatLyricTime(time) {
      const parts = String(time || "").split(":");
      if (parts.length !== 2) return 0;

      const minutes = Number(parts[0]);
      const seconds = Number(parts[1]);
      if (!Number.isFinite(minutes) || !Number.isFinite(seconds)) return 0;
      return minutes * 60 + seconds;
    },
    async loadLyric(id) {
      const token = ++this.lyricRequestToken;
      this.loading = true;
      this.lyricsObjArr = [];
      this.lyricIndex = -1;
      this.resetLyricScroll();

      if (!id) {
        this.loading = false;
        return;
      }

      try {
        const { data: res } = await this.$http.get("/lyric/" + id);
        if (token !== this.lyricRequestToken) return;

        const lyric = res && res.data && res.data[0] && res.data[0].lyric;
        if (res.code !== 200 || !lyric) {
          this.$message.error("获取歌曲歌词失败");
          return;
        }

        this.handleLyric(lyric);
        this.updateActiveLyric(this.currentTime);
      } catch (error) {
        if (token === this.lyricRequestToken) {
          this.$message.error("获取歌曲歌词失败");
        }
      } finally {
        if (token === this.lyricRequestToken) {
          this.loading = false;
        }
      }
    },
    handleLyric(lyricStr) {
      const parsed = [];
      const lineArr = String(lyricStr || "").split(/\n/);
      const regTime = /\[(\d{1,3}:\d{2}(?:\.\d{1,3})?)\]/g;

      lineArr.forEach((line, lineIndex) => {
        if (!line) return;

        const times = [];
        let match = regTime.exec(line);
        while (match) {
          times.push(match[1]);
          match = regTime.exec(line);
        }
        regTime.lastIndex = 0;

        const lyric = line.replace(regTime, "").trim();
        if (!times.length || !lyric) return;

        times.forEach((time, timeIndex) => {
          parsed.push({
            time: this.formatLyricTime(time),
            lyric,
            uid: `${lineIndex}-${timeIndex}-${time}`,
          });
        });
      });

      this.lyricsObjArr = parsed.sort((a, b) => a.time - b.time);
    },
    findLyricIndex(time, leadTime = 0) {
      const matchTime = time + leadTime;
      for (let i = this.lyricsObjArr.length - 1; i >= 0; i--) {
        if (matchTime >= this.lyricsObjArr[i].time) {
          return i;
        }
      }
      return -1;
    },
    findLyricIndexWithScrollLead(time) {
      for (let i = this.lyricsObjArr.length - 1; i >= 0; i--) {
        if (time + this.getLyricScrollDuration(i) >= this.lyricsObjArr[i].time) {
          return i;
        }
      }
      return -1;
    },
    updateActiveLyric(time, options = {}) {
      if (!this.lyricsObjArr.length) return;

      const nextIndex = options.immediate
        ? this.findLyricIndex(time)
        : this.findLyricIndexWithScrollLead(time);
      if (nextIndex === this.lyricIndex && !options.immediate) return;

      const previousIndex = this.lyricIndex;
      this.lyricIndex = nextIndex;
      this.scrollLyricTo(nextIndex, {
        immediate:
          options.immediate ||
          previousIndex < 0 ||
          Math.abs(nextIndex - previousIndex) > 2,
      });
    },
    getLyricScrollDuration(index) {
      if (index <= 0) return 0.3;

      const previousLyric = this.lyricsObjArr[index - 1];
      const currentLyric = this.lyricsObjArr[index];
      if (!previousLyric || !currentLyric) return 0.85;

      const gap = currentLyric.time - previousLyric.time;
      if (!Number.isFinite(gap) || gap <= 0) return 0.35;

      return Math.min(0.85, Math.max(0.28, gap * 0.55));
    },
    scrollLyricTo(index, options = {}) {
      this.$nextTick(() => {
        const lyricUL = this.$refs.lyricUL;
        if (!lyricUL) return;
        const duration = options.immediate
          ? 0.12
          : this.getLyricScrollDuration(index);
        lyricUL.style.setProperty("--lyric-scroll-duration", `${duration}s`);
        if (index < 0) {
          lyricUL.style.transform = "translateY(0)";
          return;
        }

        const lyricRefs = this.$refs.lyric || [];
        const activeEl = Array.isArray(lyricRefs)
          ? lyricRefs[index]
          : lyricRefs;
        const container = lyricUL.parentElement;
        if (!activeEl || !container) return;

        const translate =
          container.clientHeight / 2 -
          lyricUL.offsetTop -
          activeEl.offsetTop -
          activeEl.clientHeight / 2;
        lyricUL.style.transform = `translateY(${translate}px)`;
      });
    },
    resetLyricScroll() {
      this.$nextTick(() => {
        if (this.$refs.lyricUL) {
          this.$refs.lyricUL.style.transform = "translateY(0)";
        }
      });
    },
    getCurrentSongIndex() {
      return this.playList.findIndex((item) => this.isSameSong(item));
    },
    isSameSong(row, target = this.playContent) {
      if (!row || !target) return false;
      if (row.m_id && target.m_id) {
        return row.m_id === target.m_id;
      }
      return (
        row.songName === target.songName && row.singerName === target.singerName
      );
    },
    async nextMusic() {
      if (!this.canSwitchSong) return;
      if (this.playModeIndex === 2) {
        await this.playRandomMusic();
        return;
      }

      let index = this.getCurrentSongIndex();
      index = index === -1 ? 0 : (index + 1) % this.playList.length;
      await this.selectSong(this.playList[index], { play: true });
    },
    async lastMusic() {
      if (!this.canSwitchSong) return;

      if (this.playModeIndex === 2 && this.playList[this.lastMusicIndex]) {
        await this.selectSong(this.playList[this.lastMusicIndex], {
          play: true,
        });
        return;
      }

      let index = this.getCurrentSongIndex();
      index =
        index === -1
          ? this.playList.length - 1
          : (index - 1 + this.playList.length) % this.playList.length;
      await this.selectSong(this.playList[index], { play: true });
    },
    playMode() {
      this.playModeIndex = (this.playModeIndex + 1) % this.playModeIcon.length;
    },
    async playModeType() {
      if (this.playModeIndex === 1) {
        await this.restartCurrentSong();
      } else if (this.playModeIndex === 2) {
        await this.playRandomMusic();
      } else {
        await this.nextMusic();
      }
    },
    async playRandomMusic() {
      if (!this.canSwitchSong) {
        await this.restartCurrentSong();
        return;
      }

      const currentIndex = this.getCurrentSongIndex();
      this.lastMusicIndex = currentIndex === -1 ? 0 : currentIndex;
      let nextIndex = Math.floor(Math.random() * this.playList.length);
      if (nextIndex === currentIndex) {
        nextIndex = (nextIndex + 1) % this.playList.length;
      }
      await this.selectSong(this.playList[nextIndex], { play: true });
    },
    async restartCurrentSong() {
      const audio = this.$refs.audio;
      if (audio) {
        audio.currentTime = 0;
      }
      this.currentTime = 0;
      this.seekTime = 0;
      this.updateActiveLyric(0, { immediate: true });
      await this.playAudio();
    },
    tableRowClassName({ row }) {
      if (this.isSameSong(row)) {
        return "current_play";
      }
      return "";
    },
    async rowDblClick(row) {
      await this.selectSong(row, { play: true });
    },
    async tapShowSongContent() {
      if (!this.hasCurrentSong) return;

      this.showSongContent = !this.showSongContent;
      if (this.showSongContent) {
        this.lockBodyScroll();
        if (!this.lyricsObjArr.length && !this.loading) {
          this.loadLyric(this.playContent.m_id);
        }
        this.scrollLyricTo(this.lyricIndex, { immediate: true });
      } else {
        this.unlockBodyScroll();
      }
    },
    lockBodyScroll() {
      if (this.bodyOverflowBeforePlayer === null) {
        this.bodyOverflowBeforePlayer = document.body.style.overflow;
      }
      document.body.style.overflow = "hidden";
    },
    unlockBodyScroll() {
      if (this.bodyOverflowBeforePlayer !== null) {
        document.body.style.overflow = this.bodyOverflowBeforePlayer;
        this.bodyOverflowBeforePlayer = null;
      }
    },
    formatTime(time) {
      const totalSeconds = Math.max(0, Math.floor(Number(time) || 0));
      let f = Math.floor(totalSeconds / 60);
      let m = totalSeconds % 60;
      f = f < 10 ? "0" + f : f;
      m = m < 10 ? "0" + m : m;
      return f + ":" + m;
    },
    toggleVolume() {
      this.showVolume = !this.showVolume;
      this.changeVolume(this.volume);
    },
    changeVolume(val = this.volume) {
      const volume = Math.max(0, Math.min(100, Number(val) || 0));
      this.volume = volume;
      const audio = this.$refs.audio;
      if (audio) {
        audio.volume = volume / 100;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.mobile_menu {
  position: absolute;
  right: 12%;
  font-size: 20px;
  color: #000;
  &:hover {
    color: #ff5a8d;
  }
}
[class*="el-icon-arrow"] {
  font-size: 22px;
}
.volume {
  position: relative;
  margin: 0 2em;
  ::v-deep .el-slider {
    position: absolute;
    left: 45%;
    bottom: 80%;
  }
}
.el-table {
  margin-top: 0;
}
::v-deep .el-drawer__header {
  margin-bottom: 0;
  padding: 20px;
  background-color: #f1f2f3;
}
::v-deep .current_play {
  color: #ff5a8d;
  a {
    color: #ff5a8d;
  }
}
.el-button + .el-button {
  margin-left: 0;
}
@keyframes music {
  0% {
    transform: scaleY(0.55);
  }
  50% {
    transform: scaleY(0.25);
  }
  100% {
    transform: scaleY(0.55);
  }
}
.current_icon {
  display: inline-block;
  li {
    display: inline-block;
    width: 2px;
    height: 23px;
    margin: 0 2px;
    border-top-right-radius: 2px;
    border-top-left-radius: 2px;
    background-color: #ff5a8d;
    transform-origin: bottom;
    animation: music 1.5s 0ms infinite ease-in-out;
    &:nth-child(2) {
      animation-delay: 0.2s;
    }
    &:nth-child(3) {
      animation-delay: 0.3s;
    }
  }
}
.ctrl {
  display: flex;
  align-items: end;
  float: right;
  a {
    display: block;
    line-height: 42px;
    i {
      font-size: 22px;
      cursor: pointer;
    }
  }
  ::v-deep .el-button {
    color: #333;
    i {
      font-size: 22px;
    }
  }
}
.v-hide {
  visibility: hidden !important;
}
.c-white {
  color: #fff !important;
}
.c-999 {
  color: #999;
}
.bg {
  // background-color: rgba($color: #000000, $alpha: 0.1);
  background-color: #fff;
}
.player.bg {
  // background-color: transparent;
}
.ply2 {
  ::v-deep i {
    color: #fff;
  }
}
.player {
  box-sizing: border-box;
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 999;
  .open-play {
    position: fixed;
    right: 0;
    bottom: 40px;
    width: 40px;
    height: 40px;
    text-align: center;
    background-color: #000;
    opacity: 0.4;
    z-index: 2;
    cursor: pointer;
    i {
      font-size: 2em;
      color: #fff;
      line-height: 40px;
    }
  }
  .hint {
    position: fixed;
    right: 50px;
    bottom: 40px;
    display: flex;
    align-items: center;
    width: 120px;
    height: 50px;
    animation: identifier 1s linear 2s infinite alternate;
    &::before {
      content: "打开播放器";
      display: block;
      margin-right: 10px;
      color: #ff5a8d;
    }
    &::after {
      content: "";
      display: block;
      width: 0;
      height: 0;
      border-right: 8px solid transparent;
      border-left: 8px solid #ff5a8d;
      border-top: 8px solid transparent;
      border-bottom: 8px solid transparent;
    }
  }
  @keyframes identifier {
    0% {
      transform: translateX(-5%);
    }
    100% {
      transform: translateX(5%);
    }
  }
  .hand {
    position: absolute;
    top: -10px;
    width: 100%;
    height: 10px;
    background: linear-gradient(to right, #ff6491, #ffc19f);
    cursor: pointer;
    opacity: 0.6;
  }
  .hand:hover .all {
    display: block;
  }
  .open-play-btn {
    position: absolute;
    top: calc(78px / 2);
    right: 25px;
    transform: translateY(-50%);
    z-index: 999;
    cursor: pointer;
  }
  .content {
    display: flex;
    position: relative;
    height: calc(100vh - 0.78rem);
    background: radial-gradient(
        circle at 24% 18%,
        rgba(var(--player-theme-soft-rgb), 0.48),
        transparent 32%
      ),
      linear-gradient(
        135deg,
        rgba(var(--player-theme-soft-rgb), 0.7),
        rgba(var(--player-theme-rgb), 0.64) 46%,
        rgba(var(--player-theme-deep-rgb), 0.72)
      );
    color: #fff;
    overflow: hidden;
    // display: none;
    .img_bg {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      opacity: 0.46;
      filter: blur(52px) saturate(140%);
      object-fit: cover;
    }
    .singer_content {
      display: flex;
      position: relative;
      width: 80%;
      // min-width: 800px;
      height: 80%;
      margin: auto;
      .close {
        position: absolute;
        top: -3%;
        right: -5%;
        cursor: pointer;
      }
      .album {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        margin-right: 20px;
        .stylus {
          position: absolute;
          top: 50px;
          left: 45%;
          width: 200px;
          height: 200px;
          z-index: 99;
        }
        .stylus-rotate {
          transform: rotate(25deg);
          transform-origin: 25px 55px;
        }
        .album_img {
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;
          width: 380px;
          height: 380px;
          border-radius: 50%;
          overflow: hidden;
          animation: rotate 30s linear infinite;
          -webkit-animation: rotate 30s linear infinite;
          img {
            display: block;
            width: 60%;
            height: 60%;
            border-radius: 50%;
          }
          .msk {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: url(@/assets/images/CD.png) no-repeat center;
            // background-position: -80px -680px;
            background-size: 380px;
          }
        }
        @-webkit-keyframes rotate {
          0% {
            transform: rotate(0);
          }
          25% {
            transform: rotate(90deg);
          }
          50% {
            transform: rotate(180deg);
          }
          75% {
            transform: rotate(270deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
      }
    }
    .song_content {
      flex: 2;
      display: flex;
      flex-direction: column;
      height: 100%;
      .song_name {
        font-size: 24px;
      }
      .song_detail {
        display: flex;
        padding: 15px 0;
        .album_name,
        .singer_name {
          flex: 1;
          overflow: hidden;
          font-size: 18px;
          text-overflow: ellipsis;
          span {
            opacity: 0.6;
          }
          a {
            color: #fff;
          }
        }
      }
      .song_word_content {
        position: relative;
        flex-grow: 1;
        box-sizing: border-box;
        padding-top: 33%;
        background: linear-gradient(
          135deg,
          rgba(var(--player-theme-deep-rgb), 0.3),
          rgba(var(--player-theme-rgb), 0.28)
        );
        text-align: center;
        overflow: hidden;
        border-radius: 18px;
        box-shadow: 0 18px 50px rgba(0, 0, 0, 0.12),
          0 0 20px 10px rgba(0, 0, 0, 0.1) inset;
        backdrop-filter: blur(12px);
        .lyric {
          height: 55px;
          line-height: 55px;
          font-size: 18px;
          transition: opacity 0.25s ease, font-size 0.25s ease;
        }
        .active {
          font-size: 24px;
          opacity: 1;
        }
        .lyric_loading {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 100%;
          font-size: 1.2em;
        }
        ul {
          height: 150px;
          transition: transform var(--lyric-scroll-duration, 0.85s) ease;
          will-change: transform;
          li {
            line-height: 30px;
            height: 30px;
            opacity: 0.6;
          }
        }
      }
    }
  }
  .all {
    position: relative;
    z-index: 3;
    width: 100%;
    padding: 0 4%;
    height: 78px;
    box-shadow: 0 0 20px 10px rgba(0, 0, 0, 0.1) inset;
    //外阴影
    // box-shadow: 0 0 20px 10px rgba(0, 0, 0, 0.1);
    .g_flag {
      display: flex;
      align-items: center;
      height: 100%;
      .head {
        width: 50px;
        height: 50px;
        border-radius: 10%;
        overflow: hidden;
        position: relative;
        .modal {
          position: absolute;
          width: 100%;
          height: 100%;
          left: 0;
          top: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          background: rgba($color: #000000, $alpha: 0.4);
          opacity: 0;
          transition: all 0.2s ease;
          color: #fff;
        }
        img {
          display: block;
          width: 100%;
          height: 100%;
          border-radius: 10%;
        }
      }
      .head:hover .modal {
        opacity: 1;
      }
      .words {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 5px 0;
        margin-left: 1em;

        .title {
          display: flex;
          align-items: center;
          .song_name {
            max-width: 10em;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          a {
            margin-right: 5px;
          }
        }
        .con {
          opacity: 0.8;
          &:hover {
            opacity: 1;
          }
        }
      }
    }
    .tool {
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: 100%;
      .btns {
        display: flex;
        justify-content: center;
        align-items: center;
        .prv,
        .nxt {
          margin: 0 20px;
          color: #000;
          transition: all 0.2s ease;
          ::v-deep i {
            font-size: 20px;
          }
        }
        .ply {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 45px;
          height: 45px;
          border-radius: 50%;
          // font-size: 36px;
          color: #000;
          ::v-deep i {
            font-size: 26px;
          }
        }
        .ply:hover,
        .prv:hover,
        .nxt:hover {
          opacity: 0.75;
        }
        .lyricShow {
          font-size: 20px;
          color: #000;
          &:hover {
            color: #ff5a8d;
          }
        }
        .volumeToggle {
          display: none;
          font-size: 20px;
          color: #000;
          &:hover {
            color: #ff5a8d;
          }
        }
      }
      .mobile_volume {
        display: none;
        width: 72%;
        margin: -2px auto 0;
      }
      .g_pbar {
        .time,
        .time_end {
          font-size: 12px;
          color: #999;
          text-align: center;
        }
        ::v-deep .el-slider__button-wrapper {
          display: none !important;
          transition: all 0.3s ease !important;
        }
      }
      ::v-deep .g_pbar:hover .el-slider__button-wrapper {
        display: block !important;
      }
    }
    ::v-deep .el-slider__runway {
      margin: 10px 0 0 0;
    }
    ::v-deep .el-slider__bar {
      background-color: rgb(var(--player-theme-accent-rgb));
    }
    ::v-deep .el-slider__button {
      width: 12px;
      height: 12px;
      border: none;
      background-color: rgb(var(--player-theme-accent-rgb));
    }
  }
  &.bg {
    .all {
      background: linear-gradient(
        180deg,
        rgba(var(--player-theme-soft-rgb), 0.72),
        rgba(var(--player-theme-rgb), 0.7) 45%,
        rgba(var(--player-theme-deep-rgb), 0.62)
      );
      // border-top: 1px solid rgba(255, 255, 255, 0.22);
      box-shadow: 0 -18px 45px rgba(var(--player-theme-deep-rgb), 0.18);
      backdrop-filter: blur(18px);
    }
    ::v-deep .el-slider__runway {
      background-color: rgba(255, 255, 255, 0.3);
    }
  }
}

@media screen and (max-width: 767px) {
  .player {
    .content {
      height: calc(100vh - 82px);
      background: radial-gradient(
          circle at 50% 18%,
          rgba(var(--player-theme-soft-rgb), 0.42),
          transparent 36%
        ),
        linear-gradient(
          180deg,
          rgba(var(--player-theme-rgb), 0.5),
          rgba(var(--player-theme-deep-rgb), 0.68)
        );
      .img_bg {
        opacity: 0.42;
        filter: blur(36px);
        transform: scale(1.08);
      }
      .singer_content {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        padding: 24px 18px 18px;
        margin: 0;
        .close {
          top: 12px;
          right: 16px;
          z-index: 4;
        }
        .song_content {
          min-width: 0;
          height: 100%;
          padding-top: 28px;
          .song_name {
            max-width: 86%;
            margin: 0 auto;
            font-size: 20px;
            line-height: 28px;
            text-align: center;
          }
          .song_detail {
            flex-direction: column;
            gap: 6px;
            padding: 10px 0 16px;
            .album_name,
            .singer_name {
              flex: none;
              font-size: 14px;
              line-height: 20px;
              text-align: center;
            }
          }
          .song_word_content {
            flex: 1;
            min-height: 0;
            padding: 22vh 8px 70px !important;
            border-radius: 16px;
            background: linear-gradient(
              180deg,
              rgba(var(--player-theme-deep-rgb), 0.24),
              rgba(var(--player-theme-rgb), 0.24)
            );
            .lyric {
              height: 42px !important;
              line-height: 42px !important;
              padding: 0 6px;
              font-size: 15px;
            }
            .active {
              font-size: 18px;
              font-weight: 600;
              text-shadow: 0 2px 14px rgba(0, 0, 0, 0.24);
            }
            .lyric_loading {
              position: absolute;
              inset: 0;
              height: auto;
              font-size: 14px;
            }
            ul {
              height: auto;
            }
          }
        }
      }
    }
    .all {
      height: 82px;
      padding: 8px 12px 10px;
      .tool {
        .btns {
          min-height: 38px;
          .prv,
          .nxt {
            margin: 0 14px;
          }
          .ply {
            width: 38px;
            height: 38px;
          }
          .volumeToggle {
            display: inline-flex;
          }
        }
        .g_pbar {
          align-items: center;
          .time,
          .time_end {
            font-size: 11px;
          }
          ::v-deep .el-slider__button-wrapper {
            display: block !important;
          }
        }
        .mobile_volume {
          display: flex;
        }
      }
      ::v-deep .el-slider__runway {
        margin-top: 7px;
      }
    }
  }
}
</style>
